import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { INotification } from '@c/notifications/types';

import { notificationQueryKeys } from 'components/notifications/utilities';
import { notificationService } from 'services';
import { IResult } from 'types/api/common';

export const useFetchNotifications = () => {
  return useQuery({
    queryFn: async () => await notificationService.getNotifications(),
    queryKey: notificationQueryKeys.all,
    select: useCallback((data: IResult<INotification[]> | undefined) => {
      return data?.dataContainer ?? [];
    }, []),
  });
};
